import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@shared/components/base.component';
import * as moment from 'moment';

@Component({
  selector: 'app-project-tooltip',
  templateUrl: './project-tooltip.component.html',
  styleUrls: ['./project-tooltip.component.scss'],
})
export class ProjectTooltipComponent extends BaseComponent {
  @Input() project: any;
  @Input() mapukraine: any = false;

  constructor(public router: Router) {
    super();
  }

  goToProject(id: number) {
    this.router.navigate([`/projects/verified/${id}/`]);
  }

  getMonth() {
    let date = moment(this.project.end_job_date, 'YYYY/MM/DD');
    let months = [
      this.translate.instant('MONTHS.month_1'),
      this.translate.instant('MONTHS.month_2'),
      this.translate.instant('MONTHS.month_3'),
      this.translate.instant('MONTHS.month_4'),
      this.translate.instant('MONTHS.month_5'),
      this.translate.instant('MONTHS.month_6'),
      this.translate.instant('MONTHS.month_7'),
      this.translate.instant('MONTHS.month_8'),
      this.translate.instant('MONTHS.month_9'),
      this.translate.instant('MONTHS.month_10'),
      this.translate.instant('MONTHS.month_11'),
      this.translate.instant('MONTHS.month_12'),
    ];
    return months[parseInt(date.format('M')) - 1];
  }

  getDay() {
    let date = moment(this.project.end_job_date, 'YYYY/MM/DD');

    return date.format('D');
  }

  getYear() {
    let date = moment(this.project.end_job_date, 'YYYY/MM/DD');
    return date.format('YYYY');
  }
}
